import { h, Component } from 'preact'
import Panel from '../panel'
import ContentCurationManager from './ContentCurationManager'
import axios from 'axios'

interface Props {
  curatedTopics: Array<number>
  isActive?: boolean
  title: string
  onChange: (state: {
    curatedTopics: Array<number>
    title: string
  }) => void
}

export interface CuratedTopic {
  id: number
  type: 'question' | 'article' | 'answer' | 'discussion' | 'idea'
  title: string
  url: string
  image: null | string
  author: {
    id: number
    name: string
    url: string
    avatar: string
  }
}

interface State {
  curatedTopics: Array<CuratedTopic>,
  title: string
}

export class HomepageContentCurationManager extends Component<Props, State> {
  constructor (props: Props) {
    super()
    this.state = {
      title: props.title,
      curatedTopics: []
    }
    this.setValue = this.setValue.bind(this)
    this.afterUpdate = this.afterUpdate.bind(this)
  }

  async componentDidMount() {
    if (this.props.curatedTopics.length === 0) {
      return
    }
    const {data} = await axios.get('/contentCuration/getTopics', {
      params: {
        topicIds: this.props.curatedTopics
      }
    })
    this.setState({curatedTopics: data.content})
  }

  afterUpdate () {
    this.props.onChange({
      curatedTopics: this.state.curatedTopics.map(topic => topic.id),
      title: this.state.title
    })
  }

  setValue (key: keyof State, value: State[keyof State]) {
    if (key === 'curatedTopics' && value instanceof Array) {
      this.setState({[key]: value}, this.afterUpdate)
    } else if (key === 'title' && typeof value === 'string') {
      this.setState({[key]: value}, this.afterUpdate)
    }
  }

  shouldComponentUpdate (nextProps: Props, nextState: State) {
    return this.state !== nextState ||
      this.props.curatedTopics !== nextProps.curatedTopics ||
      this.props.isActive !== nextProps.isActive ||
      this.props.title !== nextProps.title
  }

  render (props: Props, state: State) {
    return (
      <div id='contentCurationManager'>
        <ContentCurationManager
          searchPlaceholder='Search for topics or enter a topic URL'
          onUpdate={this.setValue}
          {...state}
        />
      </div>
    )
  }
}

interface PanelProps extends Props {
  dragHandle: JSX.Element
  switcher: JSX.Element
}

const HomepageContentCurationManagerPanel = (props: PanelProps) => {
  return <Panel
        collapsible
        class='homepage-widget'
        title={<div className='qa-contentcuration-panel panel-title-with-switch'>
          <div className='homepage-reorderable-panel-title'>
            { props.dragHandle }
            <span>Recommendations</span>
          </div>
          { props.switcher }
        </div>}>
    <HomepageContentCurationManager {...props} />
  </Panel>
}

export default HomepageContentCurationManagerPanel
